import {Burger} from './js/burger.js';
import {Slider} from './js/slider.js';
import {Fade} from './js/fade.js';
import {Form} from './js/form.js';
import {newAccount} from './js/account.js';
import {selfAssessment3} from './js/index.js';



const newBurger = new Burger();
const newSlider = new Slider();
const newFade = new Fade();
const newForm = new Form();

console.log(selfAssessment3);